import { render, staticRenderFns } from "./ConfidentialityNotice.vue?vue&type=template&id=90a833f4&scoped=true&"
import script from "./ConfidentialityNotice.vue?vue&type=script&lang=js&"
export * from "./ConfidentialityNotice.vue?vue&type=script&lang=js&"
import style0 from "./ConfidentialityNotice.vue?vue&type=style&index=0&id=90a833f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a833f4",
  null
  
)

export default component.exports